import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useQuery } from "react-query";

// components
import WhiteListIA from "./contents/WhiteListAI";
import ListLogIA from "./contents/ListLogIA";
import ConnectAI from "./contents/ConnectAiReg";
import WhiteListConsole from "./contents/WhiteListConsole";
import Panel from "../../../components/panel/panel";
import SettingsAI from "./contents/SettingsAIReg";
// primereact
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { BreadCrumb } from "primereact/breadcrumb";

// context
import { useAiRegi } from "./Context/AiRegiContext";

// hooks
import usePermission from "../../../hooks/usePermission";

const SettingsFastReg = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [whitelist, setWhitelist] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setListData } = useAiRegi();
  const { state } = useLocation();

  usePermission("268");

  const items = [
  
    {
      template: () => (
        <Link to={`/quickregister`} state={{ name: state ? state.name : "Cadastro rápido" }} className="p-breadcrumb-link">
          Configurações da IA de cadastro rápido
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const handleAdd = (selectedUser, selectedPhones) => {
    return new Promise((resolve) => {
      setListData(prev => {
        if (prev.some(item => item.id === selectedUser.id)) return prev;
        return [
          ...prev,
          {
            id: selectedUser.id,
            nome: selectedUser.name,
            ativo: true,
            pessoa: {
              nome: selectedUser.name,
              contacts: selectedPhones.map(tel => ({ number: tel })), 
            },
            telefone: selectedPhones, 
          }
        ];
      });
      resolve();
    });
  };
  return (
    <div className="mb-4">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 }}>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
        {activeIndex === 1 && (
          <Button
            label="Adicionar"
            icon="pi pi-plus"
            onClick={() => setVisible(true)}
            size="large"
            className="p-button-primary p-button-lg p-button-rounded"
            style={{ marginLeft: 16 }}
          />
        )}
      </div>

      <Panel title="Configurações da IA de cadastro rápido" mainCss="mb-4">
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="meu-tabview gap-4">
          <TabPanel header="Conectar à IA de cadastro rápido" leftIcon="pi pi-qrcode mx-2" className="gap-4">
            <ConnectAI   loading={loading} />
           </TabPanel> 
          

          
            
           <TabPanel header="Lista de pessoas autorizadas" leftIcon="pi pi-users mx-2">
            <WhiteListIA
              visible={visible}
              setVisible={setVisible}
              whitelist={whitelist}
              setWhitelist={setWhitelist}
              loading={loading}
              setLoading={setLoading}
              handleAdd={handleAdd} 
            />
          </TabPanel>
          
          {/* <TabPanel header="Configurações" leftIcon="pi pi-cog mx-2">
            <SettingsAI/>
            </TabPanel> */}
          {/* <TabPanel header="Registro de atividades" leftIcon="pi pi-history mx-2">
            <ListLogIA />
          </TabPanel> */}
          
        </TabView>
        {/* <WhiteListConsole/> */}
        </Panel>
    </div>
    );
}

export default SettingsFastReg;